module.exports = __webpack_public_path__ + "img/join-us-flow-mobile.2e68babb.png";